export type SearchNavigationKey = 'ArrowDown' | 'ArrowUp';

const STEP_BY_KEY: Record<SearchNavigationKey, number> = {
  ArrowDown: 1,
  ArrowUp: -1,
};

export const isSearchNavigationKey = (key: string): key is SearchNavigationKey =>
  key in STEP_BY_KEY;

/**
 * Moves the active search result one step, wrapping at both ends.
 * Returns -1 when there is nothing to select.
 */
export const getNextResultIndex = (
  currentIndex: number,
  key: SearchNavigationKey,
  resultCount: number,
): number => {
  if (resultCount <= 0) return -1;
  if (currentIndex < 0 || currentIndex >= resultCount) {
    return key === 'ArrowDown' ? 0 : resultCount - 1;
  }
  return (currentIndex + STEP_BY_KEY[key] + resultCount) % resultCount;
};

/** Active row for the current result set; a new set starts at the first row. */
export const resolveActiveResultIndex = (
  stored: { signature: string; index: number },
  signature: string,
  resultCount: number,
): number => {
  if (resultCount <= 0) return -1;
  if (stored.signature !== signature) return 0;
  return Math.min(Math.max(stored.index, 0), resultCount - 1);
};
